import { NavigateFunction } from "react-router-dom";
import { SubjectTag } from "./SubjectTag";
import { TutorRowProfile } from "../firestore/Types/UI/TutorRowProfile";
import { CalendarDaysOfWeekSimpleAvailabilty } from "./Calendar/CalendarDaysOfWeekSimpleAvailability";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight,  faDollarSign, faGraduationCap, faLocationDot, faSchool, faStar, faUser } from "@fortawesome/free-solid-svg-icons";
import { useUtility } from "../contexts/auth/UtilityContext";

export function TutorProfileRow({ tutor, key, isSubscribed, navigate }: { tutor: TutorRowProfile, key: number, isSubscribed: boolean, navigate: NavigateFunction }) {
    const { setNewToast } = useUtility();
    
    const handleClick = () => {
        if (!isSubscribed) {
            setNewToast({ title: "Error", message: "You need to have a subscription to book a session, please link your payment method in the account page.", toastType: "error" });
            return;
        }
        navigate(`/book-session/?tutorId=${tutor.id}`);
    }
    return (
        <li key={key}>
            <div className="flex flex-col bg-white section-box mt-1">
                <div className="flex flex-row">
                    <img src={tutor.profileImage!} alt="profile" className="rounded-full border border-slate-300 md:profile-img max-md:profile-img-mobile max-md:mr-2 max-md:mt-2 md:m-2" />
                    <div className="grid grid-cols-2 grow m-2">
                        <div className="flex flex-row">

                            <div className="flex flex-col">
                                {/* <div className="flex flex-row">
                                <div className="text-sm grow">Rating: </div>
                                <div className="text-xs rounded-lg bg-blue-500 text-white p-2">{tutor.tier}</div>
                            </div> */}
                                <div className="flex flex-row gap-2 mb-2">
                                    <FontAwesomeIcon icon={faUser} title="Name" color="#4b5563" width="20px" />
                                    <div className="text-sm">{tutor.name}</div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <FontAwesomeIcon icon={faSchool} title="School" color="#4b5563" width="20px" />
                                    <div className="text-sm">{tutor.school}</div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <FontAwesomeIcon icon={faStar} title="ATAR" color="#4b5563" width="20px" />
                                    <div className="text-sm"> - </div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <FontAwesomeIcon icon={faLocationDot} title="Location" color="#4b5563" width="20px" />
                                    <div className="text-sm"> Flexible </div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <FontAwesomeIcon icon={faDollarSign} title="Price Tier" color="#4b5563" width="20px" />
                                    <div className="text-sm">Tier 1</div>
                                </div>
                                {tutor.sessions >= 10 &&
                                    <div className="flex flex-row gap-2 mb-2">
                                        <FontAwesomeIcon icon={faGraduationCap} title="Sessions" color="#4b5563" width="20px" />
                                    </div>}
                            </div>
                        </div>
                        <div className="flex flex-col grow mb-4 max-md:mt-1 max-md:mr-1">

                            {tutor.subjects.map((subject, index) => (<SubjectTag key={index} subject={subject}></SubjectTag>))}

                        </div>
                    </div>
                   
                    
                </div>
                <div className="flex flex-row gap-2 max-md:mb-1 max-md:mr-1">
                    <div className="flex flex-row grow ">
                        <div className="flex flex-row mt-2 margin-auto">
                            <CalendarDaysOfWeekSimpleAvailabilty Schedule={tutor.schedule} />
                        </div>
                    </div>
                    <div className="m-auto">
                        <button className="primary-button gap-2" onClick={handleClick}>Make a Booking <FontAwesomeIcon icon={faArrowRight}/></button>

                    </div>
                </div>
            </div>
            
        </li>
    );
}